import { Loader2, ShieldAlert } from "lucide-react";

export const RecheckBanner = ({ kit }) => {
  const r = kit.recheck;
  if (!r) return null;
  const blocked = r.state === "blocked";
  return (
    <div data-testid="recheck-banner" className={`mb-6 flex items-start gap-2 rounded-lg border p-3 text-sm ${blocked ? "border-red-200 bg-red-50 text-red-900" : "border-amber-200 bg-amber-50 text-amber-900"}`}>
      {blocked ? <ShieldAlert size={16} className="mt-0.5" /> : <Loader2 size={16} className="mt-0.5 animate-spin" />}
      <span data-testid="recheck-banner-text">
        {blocked
          ? `Your edit needs attention before this kit can ${r.relist ? "go back on sale" : "be published"}: ${r.msg}`
          : r.relist
            ? "Taken offline after your edit — re-checking every page. It goes back on sale automatically when the check passes."
            : "Edited after clearing — re-checking every page before it can be published."}
      </span>
    </div>
  );
};
